if(typeof window !=="undefined"){
    require('es6-promise').polyfill();
}
import axios from 'axios-jsonp-pro'
/* import axios from 'axios'; */

const webservice = {

    getQuizData: ()=>{
        let dataUrl = data.dataUrl + data.Id
        return axios.get(dataUrl);
    },

    submitQuizData: (data)=>{
        let dataUrl = data.submitStep
        return axios.request({
            method: 'post',
            url: dataUrl,
            data: data
        })      
    },

    submitQuizDataSecondary: (data)=>{
        let dataUrl = data.submitSecondary
        return axios.request({
            method: 'post',
            url: dataUrl,
            data: data
        })      
    },

    postCodeService: (url)=>{
        return axios.request({
            method: 'post',
            url: url
        })      
    },

    loadMapsAPI: (data)=>{
        /* return request({
            method: 'post',
            url: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded' 
            }
            //crossDomain: true,
            //withCredentials: true,
            //type : 'jsonp'
        })  */ 
        
        return axios.jsonp(data)
    }

};
export default webservice;